export default `const vec3 GDFVectors[19] = vec3[](
    normalize(vec3(1.0, 0.0, 0.0)),
    normalize(vec3(0.0, 1.0, 0.0)),
    normalize(vec3(0.0, 0.0, 1.0)),

    normalize(vec3(1.0, 1.0, 1.0 )),
    normalize(vec3(-1.0, 1.0, 1.0)),
    normalize(vec3(1.0, -1.0, 1.0)),
    normalize(vec3(1.0, 1.0, -1.0)),

    normalize(vec3(0.0, 1.0, PHI+1)),
    normalize(vec3(0.0, -1.0, PHI+1)),
    normalize(vec3(PHI+1, 0.0, 1.0)),
    normalize(vec3(-PHI-1, 0.0, 1.0)),
    normalize(vec3(1.0, PHI+1, 0.0)),
    normalize(vec3(-1.0, PHI+1, 0.0)),

    normalize(vec3(0.0, PHI, 1.0)),
    normalize(vec3(0.0, -PHI, 1.0)),
    normalize(vec3(1.0, 0.0, PHI)),
    normalize(vec3(-1.0, 0.0, PHI)),
    normalize(vec3(PHI, 1.0, 0.0)),
    normalize(vec3(-PHI, 1.0, 0.0))
  );

  
  
  float fGDF(vec3 p, float r, float e, int begin, int end) {
  	float d = 0;
  	for (int i = begin; i <= end; ++i)
  		d += pow(abs(dot(p, GDFVectors[i])), e);
  	return pow(d, 1/e) - r;
  }

  
  float fGDF(vec3 p, float r, int begin, int end) {
  	float d = 0;
  	for (int i = begin; i <= end; ++i)
  		d = max(d, abs(dot(p, GDFVectors[i])));
  	return d - r;
  }`